import { Box, useTheme } from "arkh";
import React from "react";

import Color from "color";
import { WidgetSizeT } from "../../localTypes/WidgetSizeT";
import { widgetAddSizeGreaterOrEqualTo } from "../utils/widgetAddSizeGreaterOrEqualTo";

export function WidgetSizeIndicator(props: {
  vertical?: boolean;
  widgetSizes: WidgetSizeT[];
  maxSize: WidgetSizeT;
  currentSize: WidgetSizeT;
}) {
  return (
    <Box
      style={{
        flexDirection: props.vertical ? "column" : "row",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {props.widgetSizes.map((size) => {
        const available = widgetAddSizeGreaterOrEqualTo(props.maxSize, size);
        const selected =
          size.h === props.currentSize.h && size.w === props.currentSize.w;
        return (
          <Box
            spaceHorizontal={props.vertical ? "none" : "xsmall"}
            spaceVertical={props.vertical ? "xsmall" : "none"}
            key={`${size.w}${size.h}`}
          >
            <WidgetSizeIndicatorOption
              available={available}
              selected={selected}
              size={size}
            />
          </Box>
        );
      })}
    </Box>
  );
}

const WidgetSizeIndicatorOption = React.memo(InnerWidgetSizeIndicatorOption);

function InnerWidgetSizeIndicatorOption({
  available,
  selected,
  size,
}: {
  selected: boolean;
  available: boolean;
  size: WidgetSizeT;
}) {
  const theme = useTheme();
  return (
    <Box
      borderColor={
        !available ? "border-primary" : selected ? "primary" : "washedText"
      }
      style={{
        backgroundColor: selected
          ? Color(theme.primary).lightness(95).toString()
          : undefined,
        height: size.h * 10,
        width: size.w * 10,
        borderRadius: 3,
        borderWidth: 1,
      }}
    />
  );
}
